import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/recordList/record/styles.scss';export default {
  "record": "_record_x2gmy_1",
  "input": "_input_x2gmy_9"
};